import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import Loader from '../Loader';

const ScreenLoader = ({ children, theme }) => (
    <Suspense fallback={ <div className={ theme.container }><Loader theme={ theme } /></div> }>
        {children}
    </Suspense>
);

ScreenLoader.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    theme: PropTypes.shape(),
};

export default ScreenLoader;
